<template>
  <div class="contact-us" v-html="designDetail"/>
</template>

<script>
import Vue from 'vue';
import { IsMobile } from '@/utils';
export default Vue.extend({
  name:'ContactUs',
  data () {
    return {
      designDetail:'',
      IsMobile,
    }
  },
  created(){
    this.getDesignDetailById(this.$route.params.id);
  },
  methods:{
    getDesignDetailById() {
      this.$https.get("/api/config/getConfigByType",{params:{
        type:2,
        milieu:+this.IsMobile
      }}).then((res) => {
        this.designDetail = res.data.items?.richText;
      });
    }
  }
})
</script>

